import React, { useCallback, useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";
import CommandPalette from "./CommandPalette";
import ProofModal from "./ProofModal";
import SourcingModal from "./SourcingModal";
import { SectionView } from "./SectionViews";

export default function Shell() {
  const [section, setSection] = useState("command");
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [proofState, setProofState] = useState({ open: false, mode: null, target: null });
  const [sourcingState, setSourcingState] = useState({ open: false, mode: null, target: null });
  const [stageFocus, setStageFocus] = useState(null);

  const openProof = useCallback((mode, target) => setProofState({ open: true, mode, target }), []);
  const openSourcing = useCallback((mode, target) => setSourcingState({ open: true, mode, target }), []);

  // CommandPalette + inline drill-throughs both call this. Legacy verb-tab
  // names (strategy / sentinel) are mapped onto the v0.2 section IDs.
  const navigate = useCallback((target, opts = {}) => {
    const map = {
      strategy: "command",
      opportunities: "opportunities",
      sentinel: "analyst",
    };
    setSection(map[target] || target);
    if (opts.stage) setStageFocus(opts.stage);
  }, []);

  useEffect(() => {
    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-50 flex" data-testid="unified-shell">
      <Sidebar section={section} onSection={setSection} onOpenPalette={() => setPaletteOpen(true)} />

      <div className="flex-1 flex flex-col min-w-0">
        <HeaderBar />
        <main className="flex-1 px-4 md:px-6 py-5">
          <SectionView
            section={section}
            openProof={openProof}
            openSourcing={openSourcing}
            stageFocus={stageFocus}
            onNavigate={navigate}
          />
        </main>
      </div>

      <CommandPalette
        open={paletteOpen}
        onClose={() => setPaletteOpen(false)}
        navigate={navigate}
        openProof={openProof}
        openSourcing={openSourcing}
      />

      <ProofModal
        open={proofState.open}
        onOpenChange={(o) => setProofState((s) => ({ ...s, open: o }))}
        mode={proofState.mode}
        target={proofState.target}
      />
      <SourcingModal
        open={sourcingState.open}
        onOpenChange={(o) => setSourcingState((s) => ({ ...s, open: o }))}
        mode={sourcingState.mode}
        target={sourcingState.target}
      />
    </div>
  );
}
